import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import SelectBox from '~components/ui/text-input/select-box'
import TextField from '~components/ui/text-input/text-field'
import { useSelectExtraOptionsBottomsheet } from '../../hooks/use-select-extra-options-bottomsheet'
import { PeriodDatafields, PeriodProps, SelectBoxData } from '../../types'
import SelectExtraOptionsBottomsheet from '../select-extra-options.bottomsheet'
import CheckBoxItem from '../ui/check-box-item'

/**
 * 
 * options: type select box data 호환가능하도록 교체
 */
const SelectPeriodOption = ({ root, options, onSelect }: Readonly<PeriodProps>) => {
  const initialized = useRef(false)
  const [periodValue, setPeriodValue] = useState('')
  const [stillOngoing, setStillOngoing] = useState(false)
  const {
    openSelectOptionsBottomSheet,
    setOpenSelectOptionsBottomSheet,
    onCloseRequest,
    value,
    onSelect: onPeriodUnitOptionChange,
  } = useSelectExtraOptionsBottomsheet({
    initialData: options as SelectBoxData[],
  })

  const hasInitialValue = useMemo(() => {
    return Object.values(root).some(Boolean)
  }, [root])

  const onPeriodValueChange = useCallback(
    (newValue: string) => {
      const val = parseInt(newValue, 10)
      const isNumber = !isNaN(val)
      if (!isNumber) {
        setPeriodValue('')
        onSelect({
          datafield: PeriodDatafields.value,
          value: null,
        })
        return
      }

      if (val <= 0) {
        setPeriodValue('')
      } else {
        setPeriodValue(newValue)
      }

      onSelect({
        datafield: PeriodDatafields.value,
        value: val <= 0 ? null : val,
      })
    },
    [onSelect]
  )

  const onPeriodUnitChange = useCallback(
    (selectedItem: SelectBoxData) => {
      onPeriodUnitOptionChange(selectedItem)
      onSelect({
        ...selectedItem,
        datafield: PeriodDatafields.unit,
      })
    },
    [onSelect, onPeriodUnitOptionChange]
  )

  const onPeriodUnitPress = useCallback(() => {
    setOpenSelectOptionsBottomSheet(true)
  }, [setOpenSelectOptionsBottomSheet])

  const onStillOngoingPress = useCallback(() => {
    onSelect({
      datafield: PeriodDatafields.still_ongoing,
      value: !stillOngoing,
    })
    setStillOngoing(!stillOngoing)
  }, [onSelect, stillOngoing])

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true
      if (!hasInitialValue) {
        onSelect({
          value: options[0].value,
          datafield: PeriodDatafields.unit,
        })
        onSelect({
          value: false,
          datafield: PeriodDatafields.still_ongoing,
        })
        onPeriodUnitOptionChange(options[0] as SelectBoxData)
        setStillOngoing(false)
      } else {
        setPeriodValue(root[PeriodDatafields.value])
        setStillOngoing(root[PeriodDatafields.still_ongoing])
        onPeriodUnitOptionChange({
          label: root[PeriodDatafields.unit],
          value: root[PeriodDatafields.unit],
        })
      }
    }
  }, [onSelect, hasInitialValue, root, onPeriodUnitOptionChange])

  return (
    <div>
      <div className="mb-2 flex w-full items-center flex-gap-x-2">
        <TextField
          value={periodValue}
          onChange={event => onPeriodValueChange(event.target.value)}
          pattern="[0-9]*"
          className="w-1/2"
          maxLength={3}
          showMaxLength={false}
          placeholder="3"
        />
        <SelectBox className="w-1/2">
          <SelectBox.Input
            value={value as string}
            onClick={onPeriodUnitPress}
            className="dark:border-gray-800!"
          />
        </SelectBox>
        <SelectExtraOptionsBottomsheet
          data={options as SelectBoxData[]}
          open={openSelectOptionsBottomSheet}
          value={value}
          onSelect={onPeriodUnitChange}
          onCloseRequest={onCloseRequest}
        />
      </div>
      <CheckBoxItem
        label="Still ongoing"
        value={stillOngoing}
        checked={stillOngoing}
        onChange={onStillOngoingPress}
      />
    </div>
  )
}

export default SelectPeriodOption
